import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TourActivitiesFilters } from "~/features/tour-activities/components/tour-activities-filters";
import { TourActivitiesList } from "~/features/tour-activities/components/tour-activities-list";

export const Route = createFileRoute("/activities/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <div className="ekv:w-full ekv:max-w-6xl ekv:mx-auto ekv:py-8 ekv:p-4">
      <h1 className="ekv:text-2xl ekv:font-bold ekv:mb-4">Tour Activities</h1>
      <div className="ekv:grid ekv:md:grid-cols-[300px_1fr] ekv:gap-4">
        <TourActivitiesFilters />
        <TourActivitiesList
          onViewClick={(item) => {
            navigate({
              to: `/activities/${item.id}/`,
              search: {
                startRatePax: item.start_rate_pax,
                startRate: item.start_rate,
              },
            });
          }}
        />
      </div>
    </div>
  );
}
